import { FileMetadata } from '../../types/media-assets';
import { StringMap } from '../../types/system';
import { Action } from '../redux.types';
import { METADATA_ACTIONS } from './metadata.actions';

export enum MetadataLoadingState {
  Loading,
  Completed,
}

export interface FilesMetadataState {
  map: StringMap<FileMetadata>;
  loadingState: StringMap<MetadataLoadingState>;
}

const defaultState: FilesMetadataState = {
  map: {},
  loadingState: {},
};

// TODO: this reducer is almost the same as "metadataLoader" reducer. Remove metadataLoader in favor of this one
export const metadata = (
  state: FilesMetadataState = defaultState,
  { type, payload }: Action,
): FilesMetadataState => {
  switch (type) {
    case METADATA_ACTIONS.METADATA_GET_START: {
      const { fileId } = payload.additionalData;

      return {
        ...state,
        loadingState: {
          ...state.loadingState,
          [fileId]: MetadataLoadingState.Loading,
        },
      };
    }

    case METADATA_ACTIONS.METADATA_GET_ERROR: {
      const { fileId } = payload.additionalData;

      return {
        ...state,
        loadingState: {
          ...state.loadingState,
          [fileId]: MetadataLoadingState.Completed,
        },
      };
    }

    case METADATA_ACTIONS.METADATA_GET_SUCCESS:
      const metadata: FileMetadata = payload.rawResponse;
      const { fileId } = payload.additionalData;

      return {
        ...state,
        map: {
          ...state.map,
          [fileId]: metadata,
        },
        loadingState: {
          ...state.loadingState,
          [fileId]: MetadataLoadingState.Completed,
        },
      };

    default:
      return state;
  }
};
